import 'core-js/stable/promise';

import './base.scss';
import './drupal.scss';

import backToTop from './components/back-to-top';
import cookiePolicy from './components/cookie-policy';
import './components/alert-banner';
import './components/breadcrumbs';
import './components/builder';
import './components/header';
import footer from './components/footer';
import gridGuide from './components/gridGuide';
import hero from './components/hero';
import './components/course-hero';
import personHero from './components/person-hero';
import navigation from './components/navigation';
import './components/policy-position-sub-page-card';
import cardThreeColumn from './components/card-three-column';
import './components/policy-card';
import './components/person-card';
import './components/download-block';
import './components/drupalLogin';
import './components/drupalTabs';
import './components/layout-text-block-with-quicklinks';
import './components/quicklinks';
import './components/cta';
import crossSiteSearch from './components/cross-site-search';
import './components/form-block';
import video from './components/video';
import './components/block-quote';
import './components/author-hero';
import authorAndDate from './components/author-and-date';
import anchorLinksBlock from './components/anchor-links-block';
import './components/text-block';
import imageText from './components/image-text';
import './components/image-text-block';
import accordion from './components/accordion';
import promoBlock from './components/promo-block';
import './components/benefit-list';
import newsBlogsListingHero from './components/news-blogs-listing-hero';
import './components/news-blogs-listings';
import newsBlogsListingFilters from './components/news-blogs-listing-filters';
import newsCard from './components/news-card';
import featuredNews from './components/featured-news';
import './components/news-block';
import './components/card-two-column';
import './components/category-two-column';
import './components/membership-benefit-card';
import categoryCard from './components/category-card';
import './components/image-block';
import './components/member-card';
import './components/learning-card';
import './components/search-stats';
import './components/ciob-pager';
import './components/event-page-content';
import './components/sponsor';
import './components/sponsor-list';
import speaker from './components/speaker';
import './components/speaker-list';
import './components/event-agenda';
import './components/event-details';
import './components/event-text';
import './components/event-ticket-category';
import scrollingSidebar from './components/scrolling-sidebar';
import eventListingHero from './components/event-listing-hero';
import './components/event-listings';
import eventListingCard from './components/event-listing-card';
import './components/event-hero';
import eventListingFilterModal from './components/event-listings-filter-modal';
import eventListingFilters from './components/event-listing-filters';
import eventCountryRegionalCard from './components/event-country-and-regional-card';
import './components/event-related-events';
import './layout.scss'; // layout.css must go last so the breadcrumb spacing does not get overridden
import './components/video-entity';
import './components/course-information';
import courseCardsContainer from './components/course-cards-container';
import './components/icon-set';
import providerCards from './components/provider-cards';
import accreditationCards from './components/accreditation-cards';
import './components/tags';

function run() {
  backToTop();
  eventCountryRegionalCard();
  hero();
  gridGuide();
  navigation();
  footer();
  accordion();
  crossSiteSearch();
  personHero();
  video();
  cardThreeColumn();
  authorAndDate();
  anchorLinksBlock();
  scrollingSidebar();
  newsBlogsListingHero();
  newsBlogsListingFilters();
  eventListingHero();
  eventListingCard();
  imageText();
  eventListingFilterModal();
  eventListingFilters();
  cookiePolicy();
  promoBlock();
  categoryCard();
  newsCard();
  featuredNews();
  speaker();
  courseCardsContainer();
  providerCards();
  accreditationCards();
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM fully loaded and parsed');

  if (
    !Array.prototype.keys ||
    !Array.from ||
    !Array.prototype.includes ||
    !('scrollBehavior' in document.documentElement.style)
  ) {
    Promise.all([
      import('core-js/features/array/from'),
      import('core-js/features/array/fill'),
      import('core-js/features/array/keys'),
      import('core-js/features/array/includes'),
      import('core-js/features/object/assign'),
      import('whatwg-fetch'),
      import('classlist-polyfill'),
    ]).then(run);
  } else {
    run();
  }
});
